import Vue from "vue";
import Backoffice from "@snark/backoffice";

import crudBouser from "./crud/bouser";
import crudUser from "./crud/user";
import crudAccount from "./crud/account";
import crudBuilding from "./crud/building";
import crudScenario from "./crud/scenario";
import crudProjector from "./crud/projector";
import crudCamera from "./crud/camera";
import crudProjectorBox from "./crud/projector-box";
import crudVlbox from "./crud/vlbox";
import crudLog from "./crud/log";
import crudStore from "./crud/store";
import crudGroups from  "./crud/groups"

import moment from "moment-timezone";
import axios from "axios";
moment.tz.setDefault('Europe/Paris');
moment.locale('fr');

Vue.config.productionTip = false;

Vue.use(Backoffice, {
    title: "Intenscity - BO",
    debug: true,
    apiUrl: process.env.VUE_APP_API_URL,
    apiVersion: 2,
    gmapApiKey: process.env.VUE_APP_GMAP_KEY,
    logAs: {
        token: process.env.VUE_APP_LOGAS_TOKEN,
        frontUrl: process.env.VUE_APP_LOGAS_FRONT_URL,
        apiRoute: process.env.VUE_APP_LOGAS_API_ROUTE
    },
    authenticate: async function (login, password) {
        try {
            const result = await axios.post(process.env.VUE_APP_API_AUTHENTICATE_URL, {
                username: login,
                password: password
            });
            if (result.data.token) {
                return {token: result.data.token};
            }
        }
        catch(err) {
            console.log(err);
        }
        throw "unauthorized";
    },
    crud: async function () {
        // app
        Vue.crud(crudAccount);
        Vue.crud(crudUser);
        Vue.crud(crudBuilding);
        Vue.crud(crudGroups);
        Vue.crud(crudScenario);
        Vue.crud(crudLog);
        Vue.crud(crudStore);

        // devices
        Vue.crud(crudVlbox);
        Vue.crud(crudProjector);
        Vue.crud(crudCamera);
        Vue.crud(crudProjectorBox);

        // data

        // finance

        // backoffice
        Vue.crud(crudBouser);
    },
    defaultCRUDOptions: {
        editor: {
            select: {
                sort: 'asc'
            },
            checks: {
                sort: 'asc'
            }
        }
    },
    //routes: {
    //    prepare: function (routes) {
    //    }
    //},
    menuSections: ["app", "devices", "data", "backoffice"],
    dashboardBlocks: [],
    cruds: [
        crudBouser,
        crudUser,
        crudAccount,
        crudBuilding,
        crudScenario,
        crudProjector,
        crudCamera,
        crudProjectorBox,
        crudVlbox,
        crudLog,
        crudStore,
    ],
});

Vue.backoffice.start(Vue);
